"use client";

import { useEffect, useRef } from "react";

export default function ContactFormEmbed() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Only inject once to avoid duplicate script loads on client navigations.
    const existingScript = containerRef.current.querySelector(
      'script[src="https://form.jotform.com/jsform/232135209165147"]'
    );
    if (existingScript) return;

    containerRef.current.innerHTML = "";
    const script = document.createElement("script");
    script.src = "https://form.jotform.com/jsform/232135209165147";
    script.type = "text/javascript";
    containerRef.current.appendChild(script);
  }, []);

  return <div ref={containerRef} className="w-full" />;
}
